export const delay = <T>(millis: number, value?: T): Promise<T> => {
  return new Promise<T>((resolve) =>
    setTimeout(() => resolve(value as T), millis),
  );
};

export default delay;
